import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSumologicComponent } from './simple-icons-sumologic.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSumologicComponent ],
    exports:      [ SimpleIconsSumologicComponent ],
    bootstrap:    []
})
export class SimpleIconsSumologicModule {}
